// src/pages/customerRejectedRecord/CustomerRejectedSlice.js
import { createSlice } from "@reduxjs/toolkit";
import { fetchCustomerRejectedList } from "./CustomerRejectedThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All",
    userId: null,
    locationId: null,
    customerId: null,
  },
};

const customerRejectedSlice = createSlice({
  name: "customerRejected",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomerRejectedList.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchCustomerRejectedList.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchCustomerRejectedList.rejected, (state) => {
        state.loading = false;
      });
  },
});

export const { setFilters } = customerRejectedSlice.actions;
export default customerRejectedSlice.reducer;
